// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-accordion[data-v-64ba0642]{border-radius:10.4px!important}.card-accordion .btn-accordion[data-v-64ba0642]{background:#fff!important;border-bottom-color:rgba(122,123,151,.3)!important}", ""]);
// Exports
module.exports = exports;
